import { createFileRoute } from "@tanstack/react-router";
import { LearnLayout } from "#/features/learn/components/learn-layout";

export const Route = createFileRoute("/learn")({
	component: LearnLayout,
});
